export const VALIDATE_2FA = "update_user";
export const TWO_FA_SUCCESSFUL = "two_fa_successful";
export const API_FAILED = "api_failed";
